import React from 'react';

const ContactSection: React.FC = () => {
  const [settings, setSettings] = React.useState<import('../services/settingsService').Settings>({});

  React.useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await import('../services/settingsService').then(m => m.default.getSettings());
        setSettings(data);
      } catch (error) {
        console.error('Error fetching settings for contact section:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <section id="contact" className="py-20 px-6 md:px-12 bg-canvas-primary">
      <div className="max-w-container-content mx-auto">
        <h2 className="text-4xl md:text-6xl font-bold text-center mb-16 text-fg-primary uppercase tracking-widest">
          Contacto
        </h2>
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-lg text-fg-secondary mb-8">
            ¿Tienes alguna pregunta? Estamos aquí para ayudarte.
          </p>
          <div className="space-y-4">
            <div className="flex items-center justify-center gap-3">
              <svg className="w-6 h-6 text-fg-highlight-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <a href={`mailto:${settings.company_email || 'info@topped.com'}`} className="text-fg-primary hover:text-fg-highlight-primary transition-colors">
                {settings.company_email || 'info@topped.com'}
              </a>
            </div>
            <div className="flex items-center justify-center gap-3">
              <svg className="w-6 h-6 text-fg-highlight-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <a href={`tel:${(settings.company_phone || '+573001234567').replace(/\s/g, '')}`} className="text-fg-primary hover:text-fg-highlight-primary transition-colors">
                {settings.company_phone || '+57 300 123 4567'}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
